
import { useState } from "react";
import {
  Drawer,
  Typography,
  Col,
  Table,
} from "antd";

const { Title, Text } = Typography;

import type { ColumnsType } from "antd/es/table";
import moment from "moment-timezone";
import { Order } from "../../../types/orders";
import { GET_ORDERS } from "./requests";
import { useQuery } from "@apollo/client";

interface DetailDrawerProps {
  setShowDetail: (value: boolean) => void;
  showDetail: boolean;
  selectedInoviceId?: string;
}
const DetailDrawer = ({ setShowDetail, showDetail, selectedInoviceId }: DetailDrawerProps) => {

  const [pageConfig, setPageConfig] = useState({
    page: 1,
    pageSize: 10,
  });

  const { data } = useQuery(GET_ORDERS, {
    variables: {
      params: pageConfig,
      invoiceId: selectedInoviceId,
    },
  });

  const onClose = () => {
    setShowDetail(false);
  };

  const columns: ColumnsType<Order> = [
    {
      title: "Referencia",
      align: "left",
      key: "reference",
      dataIndex: "reference",
      render: (reference) => {
        return (
          <Title level={5}>{reference}</Title>
        );
      },
    },
    {
      title: "Cliente",
      align: "left",
      dataIndex: "client",
      key: "client",
      render: (client) => (
        <Text style={{ fontWeight: "700" }}>
          {client?.user?.firstName} {client?.user.lastName}
        </Text>
      ),
    },
    {
      title: "FECHA",
      align: "left",
      dataIndex: "createdAt",
      width: 120,
      key: "createdAt",
      render: (createdAt) => (
        <Col>
          <Text>
            {createdAt ? moment(createdAt).format("DD/MM/YYYY") : "N/A"}
          </Text>
        </Col>
      ),
    },
  ];

  return (
    <Drawer
      title="Detalles de Factura"
      placement="right"
      width={"60%"}
      onClose={onClose}
      visible={showDetail}
    >
      {data?.orders?.results && (
        <Table
          title={() => <h2>Ordenes</h2>}
          dataSource={data?.orders?.results || []}
          columns={columns}
          rowKey="id"
          pagination={{
            current: Number(pageConfig.page),
            defaultCurrent: pageConfig.page,
            pageSize: Number(pageConfig.pageSize),
            defaultPageSize: pageConfig.pageSize,
            showSizeChanger: true,
            total: data?.orders?.info?.count || 0,
            showTotal: (total) => (
              <Text disabled>{`${total} resultados`}</Text>
            ),
            onChange: (page, pageSize) => {
              setPageConfig({
                page,
                pageSize,
              });
            },
          }}
        />
      )}
    </Drawer>
  );
};

export default DetailDrawer;
